import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

//create action
export const updateDepartment = createAsyncThunk(
  "updateDepartment",
  async ({ id, data, form, history }) => {
    const token = localStorage.getItem("auth_token");
        const config = {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Access-Control-Allow-Origin": '*',
                "Content-Type": "application/json",
                "Accept": "application/json",
            }
        };
    const response = await axiosHttp.patch(
      `department/update?id=${id}`,
      data,
      config
    );

    form.resetFields();
    message.success("Department successfully updated!");
    history("/app/organization/department");
    return response.data;
  }
);

const departmentUpdateSlice = createSlice({
  name: "departmentUpdate",
  initialState: {
    isLoading: false,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(updateDepartment.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(updateDepartment.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(updateDepartment.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default departmentUpdateSlice.reducer;